import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text from 'components/common/Text/Text'
import Icon from 'components/common/Icon/Icon'
import Button from 'components/common/Button/Button'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Spinner from 'components/common/Spinner'
import { SavedLocationSearchForm } from '../../../SavedLocationSearchForm'
import { activateMarchexScript } from 'helpers/custom-events'
import { SEARCH_BY_COORDS, LOCATION_FINDER_FORM } from 'constant'
import { HINT_ASK_ACCESS_GEOLOCATION, HINT_ABOUT_SECTION } from './constants'

const UseMyLocation = ({
  className,
  searchMask,
  setInitialSearchMethodAction,
  fetchLocationsByCoords,
  coords,
  isGeolocationAvailable,
  isGeolocationEnabled,
  isLoading,
  activateGoogleOptimize,
  useMyLocationClicked,
  setUseMyLocationClicked,
  reset,
  ...props
}) =>
  <Wrapper className={ className }>
    <Icon
      data-at-use-my-location-icon
      width={ 30 }
      asset="location-red"
      margin="0 0 25px"
      alt="Location icon" />
    <Text centered block size={ 18 } >{ HINT_ABOUT_SECTION }</Text>
    <ButtonWrapper>
      <Button
        data-at-use-my-location-button
        full="mobile"
        narrow
        disabled={ !coords || !isGeolocationEnabled || !isGeolocationAvailable }
        onClick={ () => {
          reset(LOCATION_FINDER_FORM)
          setInitialSearchMethodAction(SEARCH_BY_COORDS)
          fetchLocationsByCoords(coords)
          activateMarchexScript()
          activateGoogleOptimize()
          !useMyLocationClicked && setUseMyLocationClicked(true)
        } } >
        USE MY LOCATION
      </Button>
      {
        (!coords || !isGeolocationEnabled || !isGeolocationAvailable) &&
        <NoResultsWrapper>
          <UseLocationText centered block size={ 12 }>{ HINT_ASK_ACCESS_GEOLOCATION }</UseLocationText>
        </NoResultsWrapper>
      }
    </ButtonWrapper>
    <Or />
    <FormWrapper>
      <SavedLocationSearchForm
        { ...props }
        coords={ coords }
        setInitialSearchMethodAction={ setInitialSearchMethodAction }
        useMyLocationClicked={ useMyLocationClicked }
        setUseMyLocationClicked={ setUseMyLocationClicked } />
    </FormWrapper>
    {
      isLoading && <Spinner />
    }
  </Wrapper>

export default UseMyLocation

UseMyLocation.propTypes = {
  activateGoogleOptimize: PropTypes.func,
  className: PropTypes.string,
  coords: PropTypes.shape({
    longitude: PropTypes.number,
    latitude: PropTypes.number
  }),
  fetchLocationsByCoords: PropTypes.func,
  isGeolocationAvailable: PropTypes.bool,
  isGeolocationEnabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  reset: PropTypes.func,
  searchError: PropTypes.shape({
    code: PropTypes.string,
    description: PropTypes.string,
    brands: PropTypes.arrayOf(PropTypes.shape())
  }),
  searchMask: PropTypes.string,
  setInitialSearchMethodAction: PropTypes.func,
  setUseMyLocationClicked: PropTypes.func,
  useMyLocationClicked: PropTypes.bool
}

const Wrapper = styled.div`
  text-align: center;
`

const ButtonWrapper = styled.div`
  margin: 24px 0 19px;
`

const Or = styled.div`
  border-bottom: 1px solid ${Theme.colors.light_grey};
  height: 12px;
  text-align: center;

  &::after {
    display: inline-block;
    margin-top: 6px;
    padding: 0 10px;
    content: " Or ";
    background-color: ${Theme.colors.white};
    color: ${Theme.colors.black};
    ${Mixin.font.GothamBold(12)}
    line-height: 12px;
  }
`

const FormWrapper = styled.div`
  margin-top: 38px;
  ${Mixin.clearFix()}
  display: flex;
  flex-direction: column;
`

const NoResultsWrapper = styled.div`
  margin-top: 5px;
  text-align: center;
`

const UseLocationText = styled(Text)`
  padding-top: 5px;
`
